import { render, staticRenderFns } from "./LanguageIcons.vue?vue&type=template&id=09a40ee4&scoped=true"
import script from "./LanguageIcons.vue?vue&type=script&lang=js"
export * from "./LanguageIcons.vue?vue&type=script&lang=js"
import style0 from "./LanguageIcons.vue?vue&type=style&index=0&id=09a40ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a40ee4",
  null
  
)

export default component.exports